import { FileUploadSetting } from 'backend';
import { deleteUploadFile } from 'fetcher';
import { FileUploadProperty } from 'shared';
import { FileUploadSessionStateReady } from 'store';
import { handleError } from './handleError';
import { FileUploadResult, FILE_UPLOAD_RESULT_TYPE } from './models';

export type DeleteFromTemporaryPayload = {
  session: FileUploadSessionStateReady;
  setting: FileUploadSetting;
  property: FileUploadProperty;
};

export const deleteFromTemporary = async ({
  session,
  setting,
  property,
}: DeleteFromTemporaryPayload): Promise<FileUploadResult> => {
  const { subjectId } = property.inputFormat;
  try {
    const { submissionId } = session.submissionSession;
    await deleteUploadFile({
      apiRoot: setting.submissionApiOrigin,
      subjectId,
      submissionId,
    });
    return {
      type: FILE_UPLOAD_RESULT_TYPE.success,
      fileSrn: '',
      thumbnail: undefined,
    };
  } catch (e) {
    return handleError(e, setting);
  }
};
